import BitesApi from '../';

export const onboardUser = (token: string) =>
  BitesApi.post('/accounts/onboarding/', {
    token,
  });
